import { useEffect, useRef, useState } from 'react';

// images
import { hose_1, servo_splash } from '../../../images/index';

const MENU_ITEMS = [
  { id: 'opt1', label: 'Option 1', side: 'left', slot: 1 },
  { id: 'opt2', label: 'Option 2', side: 'left', slot: 2 },
  { id: 'opt3', label: 'Option 3', side: 'left', slot: 3 },
  { id: 'opt4', label: 'Option 4', side: 'right', slot: 1 },
  { id: 'opt5', label: 'Option 5', side: 'right', slot: 2 },
  { id: 'opt6', label: 'Option 6', side: 'right', slot: 3 },
];

const Skull = ({ exiting = false }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const onDocPointerDown = (e) => {
      if (!rootRef.current) return;
      if (!rootRef.current.contains(e.target)) setMenuOpen(false);
    };

    const onKeyDown = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };

    document.addEventListener('pointerdown', onDocPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onDocPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  const openMenu = () => setMenuOpen(true);
  const closeMenu = () => setMenuOpen(false);
  const toggleMenu = () => setMenuOpen((v) => !v);

  return (
    <div
      ref={rootRef}
      className={`skull__wrapper ${exiting ? 'skull--exiting' : ''} ${
        menuOpen ? 'skull--menuOpen' : ''
      }`}
      onMouseEnter={openMenu}
      onMouseLeave={closeMenu}
    >
      <button
        type="button"
        className="skullMenu__hitArea"
        aria-label="Open skull menu"
        aria-expanded={menuOpen}
        onPointerDown={(e) => {
          e.preventDefault();
          toggleMenu();
        }}
      />
      {menuOpen && (
        <div className="skullMenu__hoverShield" aria-hidden="true" />
      )}
      {/* Radial UI */}
      <div
        className="skullMenu"
        data-open={menuOpen ? 'true' : 'false'}
        aria-hidden={!menuOpen}
      >
        <div
          className="skullMenu__arc skullMenu__arc--left"
          aria-hidden="true"
        />
        <div
          className="skullMenu__arc skullMenu__arc--right"
          aria-hidden="true"
        />

        {MENU_ITEMS.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`skullMenu__item skullMenu__item--${item.side} skullMenu__item--slot${item.slot}`}
            onClick={() => {
              // placeholder action
              console.log('Clicked:', item.label);
              setMenuOpen(false);
            }}
          >
            {item.label}
          </button>
        ))}
      </div>

      {/* Existing visuals */}
      <div className="skullFloat__container">
        <img src={hose_1} className="skullHose" alt="skull hose" />
      </div>
      <img src={servo_splash} className="skullFloat" alt="skull" />
    </div>
  );
};

export default Skull;
